import { CSSObject } from '@chakra-ui/react';

export const ExoticResultedWrapper: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  px: '2',
  bg: 'zeta.400',
  mb: '2',
  flex: '1',
  color: 'alpha.800',
  fontWeight: 'medium',
  borderRadius: '6px',
  background: '#FFF',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
  border: '2px solid',
  borderColor: 'beta.600',
};

export const TypeItem: CSSObject = {
  color: 'gray.700',
  fontWeight: 'bold',
  fontSize: 'xs',
};

export const ResultRowWrapper: CSSObject = {
  border: 'none',
  borderRadius: ['base', null, 'md'],
  mb: '1',
  p: '1.5',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  bg: 'gray.100',
  _last: {
    mb: '2',
  },
};

export const ResultRowExoticWrapper: CSSObject = {
  fontSize: 'sm',
};

export const ResultRowExoticRow: CSSObject = {
  color: 'gray.500',
  fontWeight: 'bold',
  fontsize: 'sm',
};
